import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import ProviderCard from '../../components/ProviderCard';
import OfficeProviderList from './OfficeProviderList';

const OfficeProviderListWithData = ({ data: { loading, providers }, ...props }) => (
  <OfficeProviderList loading={loading} providers={providers && providers.nodes} {...props} />
);

OfficeProviderListWithData.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    providers: PropTypes.object,
  }),
};

export const OFFICE_PROVIDER_LIST_QUERY = gql`
  query OfficeProviderList($officeId: ID!, $reasonForVisitId: ID!, $specialtyId: ID, $after: String) {
    providers(
      officeId: $officeId
      reasonForVisitId: $reasonForVisitId
      specialtyId: $specialtyId
      archived: false
      perPage: 50
    ) {
      nodes {
        ...${ProviderCard.fragment.name}
      }
    }
  }
  ${ProviderCard.fragment.query}
`;

const addProviderListData = graphql(OFFICE_PROVIDER_LIST_QUERY, {
  alias: 'withProviderListData',
  options({ office, reasonForVisit, specialtyId, after }) {
    return {
      variables: {
        reasonForVisitId: reasonForVisit.id,
        specialtyId,
        officeId: office.id,
        after,
      },
    };
  },
});

export default addProviderListData(OfficeProviderListWithData);
